import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import routes from "../../Config/routes";
import { useAuthState } from "react-firebase-hooks/auth";
import firebase from "../../Modules/firebaseApp";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  }
}));

function EventGrid(props) {
  const classes = useStyles();
 const [user] = useAuthState(firebase.auth());
  const isLoggedIn = true;

  const goToEvent = (e) => {
    if(!user) {
        e.preventDefault();
        window.location.href="https://profox.live/login";
       }
	  else if(isLoggedIn)
	  {
		    e.preventDefault();
        window.location.href="https://profox.live/v/profoxlive";
	  }
    };

  return (
    <div className="eventList">
      <Grid container justify="center" spacing={3}>
         <Grid item xs={12} sm={4}>
         <Card className={classes.root}>
            <CardActionArea
             onClick={goToEvent}
            >
              <CardMedia
                className="media"
                image="https://firebasestorage.googleapis.com/v0/b/globalwoman.appspot.com/o/eventSession%2Fprofoxlive%2FLcManz3it4NWQLwut916puJpLL62%2Fbanner-1628836215559.jpg?alt=media&token=0dc331c6-475b-481c-adf7-ada302e88d2f"
                title="MRProfox 2021"
              />
              <div class="date">
                  <div class="middle">
                    <div class="inner-middle">
                      <span>13</span><p>August</p>
                    </div>
                  </div>
                </div>
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                 MRProfox Live
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  As a specialized UX company, we are dedicated to provide high-end user experiences through our unique UX designs.
                </Typography>
              </CardContent>
            </CardActionArea>
            <CardActions>
              <Button
              className="cardBtn"
              size="small"
              color="dangerCustom"
              onClick={goToEvent}
              >
                Enter
              </Button>
            </CardActions>
          </Card>
         </Grid>
       </Grid>
    </div>
  );
}

export default EventGrid;
